import { useClientTranslation } from "@/modules/App/components/i18n/i18n.client"
import {
  Button,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerTitle,
  DrawerTrigger,
} from "@dalmatech/ui"
import { Trash2 } from "lucide-react"
import Image from "next/image"
import type { ReactNode } from "react"
import { useState } from "react"

type DeletePetDrawerProps = {
  onClick: () => void
  title: string
  trigger?: ReactNode
}

export const DeletePetDrawer = ({ onClick, title, trigger }: DeletePetDrawerProps) => {
  const { t } = useClientTranslation("tribe-page")
  const [open, setOpen] = useState(false)

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        {trigger ?? (
          <Button type="button" variant="ghost" size="xs" shape="icon">
            <Trash2 className="w-5 stroke-2" />
          </Button>
        )}
      </DrawerTrigger>
      <DrawerContent onClose={() => setOpen(false)}>
        <Image
          src="/img/illus/interrogation-point.svg"
          alt="Help icon"
          width={128}
          height={128}
          draggable={false}
        />
        <DrawerTitle>{title}</DrawerTitle>
        <DrawerFooter>
          <DrawerClose onClose={() => setOpen(false)}>
            <Button size="lg" variant="ghost" className=" bg-neutral-100 text-neutral-700">
              {t("delete-pet-modal.cancel")}
            </Button>
          </DrawerClose>
          <Button
            size="lg"
            variant="destructive"
            onPointerDown={onClick}
            RightIcon={<Trash2 className="-mt-0.5 h-5 w-5 stroke-2" />}
          >
            {t("delete-pet-modal.delete")}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}
